import styled from 'styled-components'

const UnorderedList = styled.ul`
  @media (min-width: 992px) {
    display: flex;
  }
`

export { UnorderedList }
